import { render, staticRenderFns } from "./LiquidationComissionList.vue?vue&type=template&id=73834dbc&scoped=true"
import script from "./LiquidationComissionList.vue?vue&type=script&lang=js"
export * from "./LiquidationComissionList.vue?vue&type=script&lang=js"
import style0 from "./LiquidationComissionList.vue?vue&type=style&index=0&id=73834dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73834dbc",
  null
  
)

export default component.exports